import { RootState } from "../../store";
import { AccessToAccountTypeEnum } from "../accountSetupSlice";

export const accessToAccountTypeSelector = (
  state: RootState,
): AccessToAccountTypeEnum => state.accountSetup.accessToAccountType;
